import React, { Component } from 'react';

export default class Sort extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M49.822,56.072c0.152,-5.76 0.648,-10.813 1.437,-11.411c1.871,-1.418 19.416,9.808 19.416,14.712c0,4.904 -17.324,16.299 -19.416,14.714c-0.855,-0.648 -1.324,-5.454 -1.451,-11.005c-8.377,0.011 -16.753,0.025 -25.128,-0.009c-7.369,-0.093 -13.698,-6.152 -15.325,-13.624c0,0 -0.283,-1.911 0.866,-3.134c1.884,-2.004 5.289,-0.791 6.226,2.392c0.127,0.415 0.27,0.823 0.43,1.226c1.274,3.204 4.204,6.063 7.778,6.139c8.153,0.104 16.303,0 24.448,0l0.719,0Zm-19.644,-32.144c-0.152,5.76 -0.648,10.813 -1.437,11.411c-1.871,1.418 -19.416,-9.808 -19.416,-14.712c0,-4.904 17.324,-16.299 19.416,-14.714c0.855,0.648 1.324,5.454 1.451,11.005c8.377,-0.011 16.753,-0.025 25.128,0.009c7.369,0.093 13.698,6.152 15.325,13.624c0,0 0.283,1.911 -0.866,3.134c-1.884,2.004 -5.289,0.791 -6.226,-2.392c-0.127,-0.415 -0.27,-0.823 -0.43,-1.226c-1.274,-3.204 -4.204,-6.063 -7.778,-6.139c-8.153,-0.104 -16.303,0 -24.448,0l-0.719,0Z"/>
              </g>
            </svg>
        )
    }
}
